const mEditionMapPathModalDelete = {
  mEditionMapPathModalDelete: {
    alerts: {
      deleteContenidoNodo: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        successPath: 'El camino se eliminó exitosamente.',
        successStep: 'El paso se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: {
      path: 'Eliminar Camino',
      step: 'Eliminar Paso'
    }
  }
}

export default mEditionMapPathModalDelete
